import React, { useState, useEffect, useRef } from 'react';
import Head from 'next/head';
import PropTypes from 'prop-types';
import { map } from 'lodash';
// import { Checkbox } from '@rtn-web/rtn-dsm-components';
import { Button, TextInput, Text, RTNLink, SocialButton, Dropdown, Checkbox } from '@rtn-web/evergreen/';
import ReCAPTCHA from 'react-google-recaptcha';
import fetch from 'isomorphic-unfetch';
import qs from 'qs';
import { connect } from 'react-redux';
import Dimmer from '../../components/Dimmer';
import Page from '../../layouts/main';
import Helpers from '../../Utilities/Helpers';

const navConfig = require('../../userNav.json');

function CreateAccount({
  highered,
  redirect,
  userType,
  title,
}) {
  const items = [
    {
      text: 'Educator or Instructor',
      value: 'Educator or Instructor',
    },
    {
      text: 'Student or Career Seeker',
      value: 'Student or Career Seeker',
    },
    {
      text: 'Member of a Mission-Driven Organization',
      value: 'Member of a Mission-Driven Organization',
    },
    {
      text: 'Parent',
      value: 'Parent',
    },
    {
      text: 'School Counselor',
      value: 'School Counselor',
    },
  ];
  const [urlParams, setUrlParams] = useState('');
  const [testParam, setTestParam] = useState(false);
  const [failedParam, setFailedParam] = useState(false);
  const [dimmed, setDimmed] = useState(false);
  const [showVerifyForm, setShowVerifyForm] = useState(false);
  const [form, setForm] = useState({
    firstname: '',
    lastname: '',
    username: '',
    password: '',
    repeatpass: '',
    email: '',
    repeatemail: '',
    subscribe_newsletter: false,
    subscribe_newsletter_type: 0,
    agreeprivacy: false,
    recaptcha: false,
  });
  const [errors, setErrors] = useState({
    firstname: false,
    lastname: false,
    username: false,
    password: false,
    repeatpass: false,
    email: false,
    repeatemail: false,
    agreeprivacy: false,
    subscribe_newsletter_type: false,
    recaptcha: false,
  });
  useEffect(() => {
    const uriParts = window.location.href.split('?');
    const params = qs.parse(uriParts[1]) || {};
    if (params.test !== undefined) {
      setTestParam(params.test);
    }
    if (params.failed !== undefined) {
      setFailedParam(params.failed);
    }
    let newUrlParams = '';
    newUrlParams += params.redirect ? `redirect=${redirect}` : '';
    newUrlParams += params.userType ? `&userType=${userType}` : '';
    newUrlParams += highered && highered.slug ? `&highered=${highered.slug}` : '';
    setUrlParams(newUrlParams);
    return () => {};
  }, []);

  const validateFormFields = () => {
    const regexUsername = /^([a-zA-Z0-9_-]){6,15}$/;
    const regexPassword = /(?=[A-Za-z0-9@#$%^&*!]+$)^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[@#$%^&*!])(?=.{8,}).*$/;
    const regexEmail = /^([a-zA-Z+0-9._-]+@[a-zA-Z0-9._-]+\.[a-zA-Z0-9._-]+)/gi;
    let isValid = true;
    const errors = JSON.parse(JSON.stringify({}));
    if (form.firstname.length < 1) {
      isValid = false;
      errors.firstname = 'First name is required';
    }
    if (form.lastname.length < 1) {
      isValid = false;
      errors.lastname = 'Last name is required';
    }
    if (form.username.length < 1) {
      isValid = false;
      errors.username = 'User name is required';
    }
    if (form.password.length < 1) {
      isValid = false;
      errors.password = 'Password is required';
    }
    if (!form.agreeprivacy) {
      isValid = false;
      errors.agreeprivacy = 'Required Field';
    }
    if (form.subscribe_newsletter && form.subscribe_newsletter_type == 0) {
      isValid = false;
      errors.subscribe_newsletter_type = 'Required Field';
    }
    if (!form.username.match(regexUsername)) {
      isValid = false;
      errors.username = 'Invalid username format';
    }
    if (!form.password.match(regexPassword)) {
      isValid = false;
      errors.password = 'Invalid password format';
    }
    if (!form.email.match(regexEmail)) {
      isValid = false;
      errors.email = 'Invalid Email format';
    }
    if (form.email.length < 1) {
      isValid = false;
      errors.email = 'Email is required';
    }
    if (!form.recaptcha && !testParam) {
      isValid = false;
      errors.recaptcha = 'Captcha is required';
    }
    if (!isValid) setDimmed(false);
    setErrors(errors);
    return isValid;
  };
  const submitForm = async (e) => {
    e.preventDefault();
    let emailExist = false;
    let userExist = false;
    setDimmed(true);
    if (validateFormFields()) {
      await fetch(`/api/validEmail/${form.email}`)
        .then((data) => data.json())
        .then((results) => {
          console.log(results);
          if (results && results.emailIsValid) {
            emailExist = true;
          } else {
            emailExist = false;
          }
        })
        .then((emailExist) => fetch(`/api/validUsername/${form.username.toLowerCase()}`))
        .then((usernameResults) => usernameResults.json())
        .then((uname) => {
          console.log(uname);
          if (uname && uname.usernameIsValid) {
            userExist = true;
          } else {
            userExist = false;
          }
          setErrors({
            ...errors,
            username: userExist ? 'Username is already taken' : false,
            email: emailExist ? 'Email address is already in use' : false,
          });
          setDimmed(false);
        })
        .then(() => {
          if (userExist || emailExist) {
            return false;
          }
          return fetch(`/api/sendValidationEmail/${form.email}`);
        })
        .then((sent) => {
          if (!sent) {
            return;
          }
          setShowVerifyForm(true);
        });
    }
  };
  const handleKeyPress = (e) => {
    if (e.keyCode == 13) {
      submitForm(e);
    }
  };
  const submitSocialForm = (e, action_url) => {
    e.preventDefault();
    const form = document.getElementById('frm-social');
    form.action = action_url;
    form.submit();
  };

  return (
    <>
      <Head>
        <title>{title}</title>
        <meta property="og:title" content={`${title}`} />
      </Head>
      <Page>
        {dimmed && <Dimmer />}
        <div className="grid-x">
          <div className="large-6 small-6">
            <Text tag="h1" variant="h-3-default-left" text="Sign Up" />
          </div>
          <div className="large-6 small-6 text-right">
            <Text
              tag="p"
              variant="para-default-small-right"
              text="Already have an account?"
            />
            <span>
              <RTNLink
                sameWindow
                link={`/user/login?${urlParams}`}
                text="Sign In"
              />
            </span>
          </div>
        </div>
        {
          showVerifyForm ? (
            <div>
              <Text
                tag="p"
                variant="para-default-medium-left"
                text="A verification code was sent to your email address. Please check your inbox, then enter the verification code below. "
              />
              <br />
              <form
                id="frm-verify-account"
                method="POST"
                action={`/user/signup?${urlParams}`}
              >
                {
                  map(form, (val, k) => {
                    if (k !== 'validationToken') {
                      return (
                        <input type="hidden" name={k} value={val} />
                      );
                    }
                    return null;
                  })
                }
                <TextInput
                  placeholderText="12345"
                  labelText="Verification Code"
                  defaultValue={form.validationToken}
                  handleBlur={() => {}}
                  handleChange={(validationToken) => setForm({ ...form, validationToken })}
                  errorText={errors.validationToken}
                  fieldId="validationToken"
                />
                <br />
                <Button
                  type="PrimaryButton"
                  text="Verify"
                  action={(e) => {
                    const form = document.getElementById('frm-verify-account');
                    form.submit();
                  }}
                />
              </form>
              <br />
              <span>
                Didn’t receive the code?
                { ' ' }
                <Button
                  type="LinkButton"
                  action={(e) => {
                    fetch(`/api/sendValidationEmail/${form.email}`);
                  }}
                  text="Resend code"
                />
              </span>
              <br />
              <Text tag="p" variant="para-default-medium-left text-area-container p-1" text="* Note: If you refresh or navigate away from this page, you will have to start over." />
            </div>
          ) : (
            <>
              {!highered
                && (
                <>
                  <br />
                  <div
                    className="signin-list"
                  >
                    <div
                      className="pr-10"
                      style={{
                        minWidth: 'fit-content',
                        display: 'inline-block',
                      }}
                    >
                      <Text
                        tag="p"
                        variant="para-default-medium-left"
                        text="Sign up with: "
                      />
                    </div>
                    <form
                      id="frm-social"
                      className="social-form"
                      name="mySocialForm"
                      onSubmit={submitForm}
                      onKeyPress={(e) => handleKeyPress(e)}
                    >
                      <span className="inline mgr-12">
                        <SocialButton
                          name="google"
                          action={(e) => {
                            submitSocialForm(e, '/google/callback'); }}
                        />
                      </span>
                      {
                        /*
                          <span className="inline mgr-12">
                            <SocialButton
                              name="facebook"
                              action={(e) => {
                                logEvent('socialSSOClick', 'clicked to sign up with Facebook', 'socialSSOClick | Sign Up Page (https://auth.roadtripnation.com/user/signup) | Sign Up with | Go to Facebook sso');
                                submitSocialForm(e, '/auth/facebook/callback'); }}
                            />
                          </span>
                        */
                      }
                      <span className="inline mgr-12">
                        <SocialButton
                          name="linkedin"
                          action={(e) => {
                            submitSocialForm(e, '/auth/linkedin/callback'); }}
                        />
                      </span>
                    </form>
                  </div>
                </>
                )}
              <br />
              {
                failedParam === '1' && (
                  <>
                    <p aria-live="polite" className="para-default-medium-left error-box p-5">
                      Something went wrong creating your account. Please try again.
                    </p>
                    <br />
                  </>
                )
              }
              {
                failedParam === '2' && (
                  <>
                    <p aria-live="polite" className="para-default-medium-left error-box p-5">
                      Your Verification Code was incorrect. Please try again.
                    </p>
                    <br />
                  </>
                )
              }
              <Text tag="p" variant="para-default-medium-left" text="Or sign up with email:" />
              <br />
              <form
                id="frm-create-account"
                method="POST"
                action={`/user/signup?${urlParams}`}
              >
                <input type="hidden" name="highered" value={highered} />
                <input type="hidden" name="redirect" value={redirect} />
                <TextInput
                  placeholderText="First Name"
                  labelText="First Name"
                  value={form.firstname}
                  handleBlur={() => {}}
                  handleChange={(firstname) => setForm({ ...form, firstname })}
                  errorText={errors.firstname}
                  fieldId="firstname"
                />
                <br />
                <TextInput
                  placeholderText="Last Name"
                  labelText="Last Name"
                  value={form.lastname}
                  handleBlur={() => {}}
                  handleChange={(lastname) => setForm({ ...form, lastname })}
                  errorText={errors.lastname}
                  fieldId="lastname"
                />
                <br />
                <TextInput
                  placeholderText="Username"
                  labelText="Username"
                  value={form.username}
                  handleBlur={() => {}}
                  handleChange={(username) => setForm({ ...form, username })}
                  helpText="Must be 6-15 characters, no special characters allowed except “-“ and “_”"
                  errorText={errors.username}
                  fieldId="username"
                />
                <br />
                <TextInput
                  placeholderText="Email"
                  labelText="Email"
                  value={form.email}
                  handleBlur={() => {}}
                  handleChange={(email) => setForm({ ...form, email })}
                  errorText={errors.email}
                  fieldId="email"
                />
                <br />
                {/* new form doesnt include pass repeat but so am setting both pass and pass repeat here */}
                <TextInput
                  placeholderText="Password"
                  labelText="Password"
                  value={form.password}
                  handleChange={(password) => setForm({
                    ...form,
                    password,
                    repeatpass: password,
                  })}
                  helpText="Must include: 8 or more characters, 1 number, 1 uppercase letter, 1 lowercase letter, 1 of these special characters: $ ! @ # % & * ^"
                  errorText={errors.password}
                  handleBlur={() => {}}
                  fieldId="password"
                  type="password"
                  eyeball
                />
                <br />
                {!testParam && (
                  <div className="recaptcha">
                    <ReCAPTCHA
                      sitekey="6Levy_MZAAAAAJGkbbvgWTBVhGcJmhli7_MTSBaz"
                      onChange={(e) => {
                        setForm({
                          ...form,
                          recaptcha: !form.recaptcha,
                        });
                      }}
                    />
                    {errors.recaptcha
                      && (
                        <div className="text-error">
                          Captcha is required
                        </div>
                      )}
                  </div>
                )}
                <br />
                <Checkbox
                  value={form.agreeprivacy}
                  // handleChange={(e, agreeprivacy) => {
                  handleChange={(agreeprivacy) => {
                    // e.preventDefault();
                    setForm({ ...form, agreeprivacy });
                  }}
                  error={errors.agreeprivacy}
                  fieldId="agreeprivacy"
                >
                  <span>I agree to the </span>
                  <a className="checkbox-link" href={`${navConfig.COM}/legal/tos`}>Terms of Use</a>
                  <span> and </span>
                  <a className="checkbox-link" href={`${navConfig.COM}/legal/privacy`}>Privacy Policy</a>
                </Checkbox>
                <br />
                {
                  userType !== 'nocontact' && (
                    <>
                      <Checkbox
                        text=" I would like to sign up for the Roadtrip Nation newsletter (optional)"
                        value={form.subscribe_newsletter}
                        // handleChange={(e, subscribe_newsletter) => {
                        handleChange={(subscribe_newsletter) => {
                          // e.preventDefault();
                          setForm({ ...form, subscribe_newsletter }); }}
                        fieldId="subscribe_newsletter"
                      />
                      <br />
                    </>
                  )
                }
                {form.subscribe_newsletter
                  && (
                    <Dropdown
                      labelText="Which of these best describes you?"
                      labelTextVariant="para-default-small-left"
                      items={items}
                      isMobile={Helpers.isMobile()}
                      fieldId="subscribe_newsletter_type"
                      error={errors.subscribe_newsletter_type}
                      value={form.subscribe_newsletter_type}
                      handleChange={(type) => {
                        setForm({
                          ...form,
                          subscribe_newsletter_type: type,
                        }); }}
                    />
                  )}
                <br />
                <br />
                <Button
                  type="PrimaryButton"
                  text="Create Account"
                  action={(e) => submitForm(e)}
                />
              </form>
            </>
          )
        }
      </Page>
    </>
  );
}

CreateAccount.getInitialProps = async ({
  req, res, match, history, location, ...ctx
}) => { return { title: 'Signup' }; };

function mapStateToProps({ main }) {
  return {
    redirect: main.redirect,
    userType: main.userType,
    highered: main.highered,
  };
}

export default connect(
  mapStateToProps,
)(CreateAccount);

CreateAccount.propTypes = {
  redirect: PropTypes.string.isRequired,
  userType: PropTypes.oneOfType([
    PropTypes.bool,
    PropTypes.string,
  ]).isRequired,
  highered: PropTypes.oneOfType([
    PropTypes.bool,
    PropTypes.string,
  ]).isRequired,
  title: PropTypes.string,
};

CreateAccount.defaultProps = {
  title: 'Sign Up',
};
